module.exports = __webpack_public_path__ + "img/weixin.7757bc53.jpg";